import { useSyncExternalStore } from 'react';

/**
 * Returns `true` on the client after hydration, `false` on the server.
 * Use this to guard client-only rendering (portals, browser APIs, etc.)
 * without triggering hydration mismatches.
 */
export function useIsMounted(): boolean {
    return useSyncExternalStore(
        () => () => {},
        () => true,
        () => false
    );
}
